import { Table, TableBody, TableCaption } from 'design-system';

import type { FullScreenLegendSeries } from '../fullScreenChartTypes';
import LegendTableHeader from './LegendTableHeader';
import LegendTableRow from './LegendTableRow';

interface FullScreenLegendProps {
  onToggleSeries: (seriesId: string) => void;
  series: FullScreenLegendSeries[];
}

const FullScreenLegend = ({ onToggleSeries, series }: FullScreenLegendProps) => (
  <section
    aria-label='Chart series legend'
    className='max-h-40 w-full overflow-auto pr-6 pt-2'
  >
    <Table>
      <TableCaption className='sr-only'>Visible chart series</TableCaption>
      <LegendTableHeader />
      <TableBody>
        {series.map(item => (
          <LegendTableRow
            key={item.id}
            item={item}
            onToggleSeries={onToggleSeries}
          />
        ))}
      </TableBody>
    </Table>
  </section>
);

export default FullScreenLegend;
